import Vue from 'vue'
import Vuex from 'vuex'
import attachCognitoModule from '@vuetify/vuex-cognito-module'
const UserPool = 'us-west-2_XZPdfCwcx'
const IdPool = 'us-west-2:89854e74-acf3-41a2-b83d-3b706eacdc61'
const WebClient = '3d5od6g77ms89a8mn0jeups50'
const App = 'generaluser'
const OrgKey = 'volleyforlife'
Vue.use(Vuex)

const set = property => (store, payload) => (store[property] = payload)

const store = new Vuex.Store({
  state: {
    eventId:155,
    maxteams:24,
    url: (process.env.NODE_ENV === 'development') ? 'http://localhost:3002/' : 'https://api.18panels.com/',
    dev: (process.env.NODE_ENV === 'development'),
    icons:{
      group:'fas fa-users',
      trash:'fas fa-trash ',
      ban:'fas fa-ban',
      undo:'fas fa-undo',
      close:'fas fa-times',
      plus:'fas fa-plus',
      minus:'fas fa-minus-square',
      thumbsup:'far fa-thumbs-up',
      thumbsdown:'far fa-thumbs-down',
      error:'far fa-thumbs-down',
      success:'far fa-thumbs-up',
      folder:'far fa-folder',
      edit:'far fa-edit',
      contact:'far fa-address-card',
      send:'fas fa-location-arrow',
      checkon:'fas fa-check-square',
      checkoff:'far fa-check-square',
      info:'fas fa-exclamation-circle',
      search:'fas fa-search',
      copy:'far fa-copy',
      warning:'fas fa-exclamation-triangle',
      question:'far fa-question-circle',
      user:'fas fa-user-circle',
      sms: 'fa fa-sms',
      email: 'far fa-envelope-open',
      voicemail:'fas fa-voicemail',
      instagram: 'fab fa-instagram',
      paypal: 'fab fa-paypal',
      stripe: 'fab fa-stripe-s',
      dashboard: 'fas fa-tachometer-alt',
      calendar: 'far fa-calendar-alt',
      clock: 'far fa-clock',
      home: 'fas fa-home'
    },
    stripeClient: (process.env.NODE_ENV === 'development') ? 'pk_test_LdlO17GauZaC9PlbmKeavr6q' : 'pk_live_iv1VpOJUjQLIEIuBAqHO9zH7', //18panels codes
    productid: (process.env.NODE_ENV === 'development') ?  'prod_GBJjaPI0h3sc6y' : 'prod_GApVmCy34mZonH',
    event:undefined,
    email: '',
    username:'',
    confirmationcode:'',
    isLoading: false,
    isReady: false,
    loggedin:false,
    password: '',
    color1:'black',
    color2:'light-blue',
    coloron:'blue',
    colorhex:'#01579B',
    snackbar: {},
    appdata:false,
    org:undefined,
    rules:{
      nameRules: v => { if(v) { return (v === v ) || 'Name' } else return true },
      emailRules: v => { if(v) { return /.+@.+\..+/.test(v) || 'E-mail must be valid' } else {return true} },
      cellRules: v => { if(v) { return (v && (v.length === 10 && /^[0-9]/.test(v))) || '10 digit cell phone format' } else {return true}},
      usernameRules: v => { return v &&  (   (v.length === 10 && /^[0-9]/.test(v))  || /.+@.+\..+/.test(v) ) || 'Valid email or cell' },
      required: v => !!v || 'Required'
    },
    notifications:[],
    customer:undefined,
    products:undefined,
    plans:undefined,
    version:'...',
    newcontent:false,
    contactinfoschema: {
      cell: undefined,
      email: undefined,
      emailverified:false,
      id: undefined,
      name: undefined,
      updatedAt: undefined,
      uuid: undefined,
      nickname: undefined,
      customeid: undefined,
      status: undefined
    },
    idpool: IdPool,
    app:App,
    client:WebClient,
    pool:UserPool,
    appstate:'normal', //ie registering, etc..
    registrants:undefined,
    step:1,
    activesku:false,
    orders:undefined,
    registered: undefined, // { "order": { "id": "or_1FhNJoLjqMoZ7bO376c39nLj", "object": "order", "amount": 8300, "amount_returned": null, "application": null, "application_fee": null, "charge": null, "created": 1574372164, "currency": "usd", "customer": "cus_GDmR8lcRlgn0G2", "email": "bribrink@gmail.com", "items": [ { "object": "order_item", "amount": 8300, "currency": "usd", "description": "CoatesNHoffTest2019", "parent": "sku_GBZcutbc0XXVk8", "quantity": 1, "type": "sku" }, { "object": "order_item", "amount": 0, "currency": "usd", "description": "Taxes (included)", "parent": null, "quantity": null, "type": "tax" }, { "object": "order_item", "amount": 0, "currency": "usd", "description": "Free shipping", "parent": "ship_free-shipping", "quantity": null, "type": "shipping" } ], "livemode": false, "metadata": { "eventid": "155" }, "returns": { "object": "list", "data": [], "has_more": false, "total_count": 0, "url": "/v1/order_returns?order=or_1FhNJoLjqMoZ7bO376c39nLj" }, "selected_shipping_method": "ship_free-shipping", "shipping": null, "shipping_methods": [ { "id": "ship_free-shipping", "amount": 0, "currency": "usd", "delivery_estimate": null, "description": "Free shipping" } ], "status": "created", "status_transitions": { "canceled": null, "fulfiled": null, "paid": null, "returned": null }, "updated": 1574372164 }, "paid": { "id": "or_1FhNJoLjqMoZ7bO376c39nLj", "object": "order", "amount": 8300, "amount_returned": null, "application": null, "application_fee": null, "charge": "ch_1FhNJoLjqMoZ7bO31VYtMFb7", "created": 1574372164, "currency": "usd", "customer": "cus_GDmR8lcRlgn0G2", "email": "bribrink@gmail.com", "items": [ { "object": "order_item", "amount": 8300, "currency": "usd", "description": "CoatesNHoffTest2019", "parent": "sku_GBZcutbc0XXVk8", "quantity": 1, "type": "sku" }, { "object": "order_item", "amount": 0, "currency": "usd", "description": "Taxes (included)", "parent": null, "quantity": null, "type": "tax" }, { "object": "order_item", "amount": 0, "currency": "usd", "description": "Free shipping", "parent": "ship_free-shipping", "quantity": null, "type": "shipping" } ], "livemode": false, "metadata": { "eventid": "155" }, "returns": { "object": "list", "data": [], "has_more": false, "total_count": 0, "url": "/v1/order_returns?order=or_1FhNJoLjqMoZ7bO376c39nLj" }, "selected_shipping_method": "ship_free-shipping", "shipping": null, "shipping_methods": [ { "id": "ship_free-shipping", "amount": 0, "currency": "usd", "delivery_estimate": null, "description": "Free shipping" } ], "status": "paid", "status_transitions": { "canceled": null, "fulfiled": null, "paid": 1574372164, "returned": null }, "updated": 1574372164 }, "participants": [ { "partkey": "d2b964f6-7c17-4444-9e9e-3ac0ddbf385a", "pin": "CZWM", "club": "scottsdalebeachfest", "sport": "beach", "firstname": "Nate", "lastname": "Coonce", "gradyear": 0, "profilepic": "https://athleteforlife.org/static/volleyhead.jpg", "email": "coonce_n@hotmail.com", "sandrecruit": null, "active": 0, "committed": 0, "school": "", "logo": "", "createdAt": "2019-06-15T00:03:56.000Z", "updatedAt": "2019-06-15T00:03:56.000Z" }, { "partkey": "39a6a5ff-78ec-4c9a-aa35-9140dc792813", "pin": "UVZE", "club": "scottsdalebeachfest", "sport": "beach", "firstname": "Shawn", "lastname": "Coates", "gradyear": 0, "profilepic": "https://athleteforlife.org/static/volleyhead.jpg", "email": "shawn@coatesirrigation.com", "sandrecruit": null, "active": 0, "committed": 0, "school": "", "logo": "", "createdAt": "2019-06-15T00:06:23.000Z", "updatedAt": "2019-06-15T00:06:23.000Z" } ] }
    registration:undefined
  },
  mutations: {
    setEmail: set('email'),
    setUsername: set('username'),
    setIsReady: set('isReady'),
    setIsLoading: set('isLoading'),
    setLoggedIn: set('loggedin'),
    setPassword: set('password'),
    setUser: set('user'),
    setSnackbar: set('snackbar'),
    setAppData: set('appdata'),
    setNtfs: set('notifications'),
    setNewContent: set('newcontent'),
    setEvent: set('event'),
    setConfirmationCode: set('confirmationcode'),
    setCustomer: set('customer'),
    setOrders: set('orders'),
    setAppState: set('appstate'),
    setRegistrants: set('registrants'),
    setRegistrationStep: set('step'),
    setActiveSku: set('activesku'),
    setRegistered: set('registered'),
    setRegistration: set('registration'), //fullevent registration list
  },
  actions: {
    async post (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async put (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async get (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          }
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
                store.commit('setSnackbar', {
                  type: c[error.error.statuscode],
                  msg: error.error.message,
                  timeout: 5000
                })
          reject(error)
        })
      })
    },


    async delete (state, data) {
      let session = await store.dispatch('cognito/fetchSession');
      return new Promise((resolve, reject) => {
        let options = {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.accessToken.jwtToken,
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{ console.log(error)
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    async fetch (state, args) {
      let session = await store.dispatch('cognito/fetchSession');
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        'Pool': UserPool,
        'Org': OrgKey,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        let c = {
          '400':'warning'
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
              store.commit('setSnackbar',{
                type: c[error.error.statuscode],
                msg: error.error.message,
                timeout:5000
              })
              reject(error)
        })
      })
    },


    async openFetch (state, args) {
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.accessToken.jwtToken,
        'Pool': UserPool,
        'Org': OrgKey,
        'App':App
      }
      let data = args.data
      let options = {}
      return new Promise((resolve, reject) => {
        if (args.method == 'GET') {
          options = {
            method: args.method,
            headers: headers
          }
        } else {
          options = {
            method: args.method,
            headers: headers,
            body: JSON.stringify(data)
          }
        }
        fetch(args.url, options)
            .then((response) => response.json())
            .then((response) => {
              resolve(response)
            })
      }, error => {
        reject(error)
      })
    },


    async openPost (state, data) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          },
          body: JSON.stringify(data.body)
        }


        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              if(response.error && response.error.code){
                this.dispatch('showError',response)
              }
              resolve(response)
            }).catch(error=>{

          reject(error)
        })
      })
    },


    async openGet (state, data) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Pool': UserPool,
            'Org': OrgKey,
            'App':App
          }
        }
        let c = {
          '400':'warning'
        }

        fetch(store.state.url + data.path, options)
            .then((response) => response.json())
            .then((response) => {
              console.log(response)
              if(response.error && response.error.code){
                store.commit('setSnackbar',{
                  type: c[response.error.statuscode],
                  msg: response.error.message,
                  timeout:5000
                })
              }
              resolve(response)
            }).catch(error=>{
          store.commit('setSnackbar',{
            type: c[error.error.statuscode],
            msg: error.error.message,
            timeout:5000
          })
          reject(error)
        })
      })
    },


    refreshAuth(){
      store.dispatch('cognito/fetchSession')
          .finally(() => {
            store.commit('setIsReady', true)
            if (!store.getters['cognito/isLoggedIn']) return
            store.commit('setLoggedIn',true)
            // move this to somewhere else.. it will get called way too much here...
            store.dispatch('getAppData')
          })
    },


    getAppData () {
      let args = {
        url: store.state.url + 'api/auth/authrecordv2',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            store.dispatch('putAppOrg',response)
            store.dispatch('getCustomer')
          })
          .catch(function (e) {
            console.log(e)
          })
    },


    putAppOrg (state,data) {
      let nts = []
      // if(!data.org){
      //   nts.push({code:"apporg",text:"Set up your App/Organization",icon:"fas fa-exclamation",to:"/account/organization"})
      // }
      if(data.appdata.notifications){
        Object.keys(data.appdata.invitations).forEach(function(n){
          let nt = data.appdata.notifications[n]
          nts.push({code:nt.type, text:nt.text, icon:n.logo,logo:nt.logo, to:nt.to})
        })
      }
      if(data.org){
        store.commit('setOrg',data.org)
        store.commit('setMyOrgs',Object.values(data.appdata.orgs))
        store.commit('setPermissions',data.permissions)
      }
      if(data.appdata){
        store.commit('setAppData',data.appdata)
        // store.commit('setMyOrgs',Object.values(data.appdata.orgs))
      }
      if(nts){
        store.dispatch('addNtfs',nts)
      }
    },


    signout () {
      store.dispatch('cognito/signOut');
      store.commit('setAppData',{})
      // store.commit('setContacts',false)
      // store.commit('setGroups',false)
      // store.commit('setMyOrgs', [])
      // store.commit('setOrg',undefined);
      window.location.reload()
    },


    async getCustomer() {
      let args = {
        url: store.state.url + 'api/payments/stripegeneralusers/customer',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            if (response === null || response.error) {
              //IMPORTANT - 'false' = NO CUSTOMER RECORD THROUGH STRIPE YET.
              store.commit('setCustomer',false)
            } else {
              store.commit('setCustomer',response)
              store.dispatch('getOrders')
            }
          }).catch(e => {
            console.log(e)

            store.commit('setCustomer',false)
      })
    },


    async getProducts() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyproducts',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            if(response.length > 0){
              store.commit('setProducts',response)
              store.dispatch('getPlans')
            } else {
              store.commit('setProducts',false)
              store.commit('setPlans',false)
            }
          }).catch(function (e) {
          em.creatingcustomer = false;
        console.log(e)
      })
    },


    async getPlans() {
      let em = this;
      let args = {
        url: store.state.url + 'api/payments/stripe18panels/textappyplans',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            let plans = response
            plans.sort((a,b)=>(a.amount<b.amount)?1:-1)
            store.commit('setPlans',plans)
          }).catch(function (e) {
        em.creatingcustomer = false;
        console.log(e)
      })
    },


    async getOrders() {
      let args = {
        url: store.state.url + 'api/payments/stripegeneralusers/orders',
        method: 'GET'
      }
      store.dispatch('fetch', args)
          .then(function (response) {
            console.log(response)
            if (response === null || response.error) {
              //IMPORTANT - 'false' = NO CUSTOMER RECORD THROUGH STRIPE YET.
              store.commit('setOrders',false)
            } else {
              store.commit('setOrders',response)
            }
          }).catch(e => {
        console.log(e)

        store.commit('setCustomer',false)
      })
    },

    removeNtfs(state,item){
      let n = store.state.notifications;
      if(typeof n === 'boolean') {
        return
      } else {
        n = store.state.notifications.splice(0)
      }
      if(n.length===1){
        store.commit('setNtfs',false)
      } else {
        let index = n.findIndex(f=>{return f.code === item.code})
        let data = n.splice(index,1)
        store.commit('setNtfs',data)
      }

    },

    addNtfs(state,items){
      let n = store.state.notifications;
      if(typeof n === 'boolean') {
        n = []
      } else {
        n = store.state.notifications.splice(0)
      }
      let ln = items.length;
      for(let i=0; i<ln;i++){
        n.push(items[i])
      }
      store.commit('setNtfs',n)
    },

    reLoad(){
      window.location.reload(true)
    },

    showError(state,e){
      let c = {
        '400':'warning'
      }
      store.commit('setSnackbar',{
        type: c[e.error.statuscode],
        msg: e.error.message,
        timeout:e.timeout || 5000
      })
      return;
    },


    async getRegistrationList(state,id){
      let t = await store.dispatch('openGet',{path:'api/event/registrationlist/'+id})
      store.commit('setRegistration',t)
    }

  }
})

attachCognitoModule(store, {
  userPoolId: UserPool,
  identityPoolId: IdPool,
  userPoolWebClientId: WebClient,
  region: "us-west-2"
}, 'cognito')

store.dispatch('refreshAuth')

export default store
